import styled from 'styled-components';

export const DetailsButtonWrap = styled.div`
  position: fixed;
  bottom: 40px;
  left: 50px;
  cursor: pointer;
  padding: 14px 34px;
  background-color: ${props => props.theme.colors.primary};
  color: #fff;
  z-index: 2;
  font-size: 18px;
  font-weight: 500;
  border-radius: 5px;
  display: flex;
  align-items: center;
`;

export const TitleWrap = styled.div`
  margin-left: 10px;
  margin-top: 6px;
`;

export const IconWrap = styled.div<{
  isOpen: boolean;
}>`
  // transform: ${isOpen => (isOpen ? 'rotate(45deg)' : 'rotate(0deg)')};
  ${({ isOpen }) => isOpen && 'transform: rotate(45deg);'};
  margin-top: 8px;
  transition: transform 0.3s ease-in-out;
`;

export const DescriptionWrap = styled.div`
  position: absolute;
  width: 400px;
  height: 308px;
  left: 50px;
  bottom: 120px;
  z-index: 2;
  padding: 20px 25px;
  overflow-y: auto;

  background: rgba(255, 255, 255, 0.93);
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
`;
